<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'dsaManagement.emailTemplates.edit'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="cancel()">
      {{ t('buttons.cancel') }}
    </htx-button>

    <div class="panel">
      <div class="edit-header">
        <div class="header-title-section">
          <h1 class="header-title">{{ templateName() || t('title') }}</h1>
          <p class="header-subtitle">{{ t('subtitle') }}</p>
        </div>
        <div class="header-actions">
          <htx-button variant="tertiary" icon="restart_alt" (click)="reset()">
            {{ t('buttons.reset') }}
          </htx-button>
          <htx-button
            variant="primary"
            icon="save"
            (click)="save()"
            [disabled]="form.invalid || saving()"
          >
            {{ t('buttons.save') }}
          </htx-button>
        </div>
      </div>

      <div class="edit-layout" [formGroup]="form">
        <!-- Row 1: subject (edit / preview) -->
        <htx-text-field-with-error
          class="subject-edit"
          [ctrl]="form.controls.subject"
          [label]="t('fields.subject')"
        ></htx-text-field-with-error>

        <div class="subject-preview">
          <span class="preview-label">{{ t('fields.subject') }}</span>
          <div class="subject-value-box">{{ previewSubject() }}</div>
        </div>

        <!-- Row 2: HTML body editor / live preview -->
        <div class="body-edit">
          <app-html-code-editor
            [label]="t('fields.bodyHtml')"
            formControlName="bodyHtml"
          ></app-html-code-editor>
          <p class="body-hint">{{ t('bodyHint') }}</p>
        </div>

        <div class="body-preview">
          <span class="preview-label">{{ t('preview.title') }}</span>
          @if (previewError()) {
            <htx-alert
              variant="danger"
              [title]="t('preview.error')"
              [message]="previewError()!"
            ></htx-alert>
          } @else {
            <iframe
              #previewFrame
              class="preview-frame"
              title="preview"
              sandbox="allow-same-origin"
            ></iframe>
          }
        </div>
      </div>
    </div>
  </div>
</app-protected-content>
